 const documentConfig = [
    { ext: "doc", name: "Doc", icon: "/images/document/word.png" },
    { ext: "docx", name: "Docx", icon: "/images/document/word.png" },
    { ext: "zip", name: "Zip", icon: "/images/document/zip.png" },
    { ext: "pdf", name: "Pdf", icon: "/images/document/pdf.png" },
    { ext: "xls", name: "Excel", icon: "/images/document/excel.png" },
    { ext: "xlsx", name: "Excel", icon: "/images/document/excel.png" },
    { ext: "csv", name: "Excel CSV", icon: "/images/document/excel.png" },
    { ext: "jpg", name: "Image", icon: "/images/document/image.png" },
    { ext: "png", name: "Image", icon: "/images/document/image.png" },
    { ext: "jpeg", name: "Image", icon: "/images/document/image.png" },
    { ext: "mp3", name: "Audio", icon: "/images/document/audio.png" },
    { ext: "mp4", name: "Video", icon: "/images/document/video.png" },
    { ext: "ppt", name: "ppt", icon: "/images/document/ppt.png" },
    { ext: "pptx", name: "pptx", icon: "/images/document/ppt.png" },
    { ext: "rar", name: "rar", icon: "/images/document/rar.png" },
  ];

  export default documentConfig;